import {
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);

  const token = sessionStorage.getItem('token');

  let authReq = req;

  if (token && !req.url.includes('/login')) {

    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  if (authReq.method === 'GET' && authReq.url.startsWith(environment.apiUrl)) {
    authReq = authReq.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
      params: authReq.params.set('_ts', Date.now().toString()),
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {

      if (error.status === 401) {

        sessionStorage.clear();

        router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};